module.exports = __webpack_public_path__ + "fonts/droid-sans-mono.d703464.otf";